import React from 'react';
import { Link } from 'react-router-dom';
import EditIcon from '@mui/icons-material/Edit';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

export default function FastEdit({ aaroOrderID }) {
    return (
        <Tooltip title="Düzenle" placement="top">
            <IconButton
                color="info"
                component={Link}
                to={`../orders/${aaroOrderID}`}
                target="_blank"
                rel="noopener noreferrer"
                size="small"
            >
                <EditIcon fontSize="small" />
            </IconButton>
        </Tooltip>
    );
}
